import { createContext, useContext } from 'react';

import type { PopupContextProps } from './popup.types';

export const PopupContext = createContext<null | PopupContextProps>(null);

export function usePopupContext(): PopupContextProps {
  return useContext(PopupContext);
}
